export default "__VITE_ASSET__BCRSvTfa__"